// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"26767197","453":"7953c634","455":"46133a83","977":"d2182211"}[chunkId] + ".chunk.js";
};